import React, { useState, useEffect } from "react";

import useBarber from "../../hooks/barber/useBarber.jsx";
import AddEditBarber from "./add-edit-barber.jsx";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal.jsx";
import plusIcon from "../../assets/icons/plus-icon.png";
import EditIcon from "../../assets/icons/edit-icon.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";
import saveIcon from "../../assets/icons/save-icon.png";
import Breadcrumb from "../../components/Breadcrumb.jsx";
import Table from "../../components/Table/Table.jsx";
const Barbers = () => {
  const {
    barberList,
    showModal,
    sectionRef,
    editbarber,
    showDeleteModal,
    errorMsg,
    successMsg,
    onClearbarber,
    handleDeleteClick,
    handleConfirmDelete,
    setShowModal,
    fetchBarbers,
    onEditClick,
    onCloseDeleteModal,
  } = useBarber();
  const image_url = process.env.REACT_APP_Image_APP_URL;
  if (barberList == null) {
    return <div>loading...</div>;
  }
  const columns = [
    { header: "First Name", accessor: "firstName" },
    { header: "Last Name", accessor: "lastName" },
    { header: "Email", accessor: "email" },
    { header: "Phone", accessor: "phoneNumber" },
    { header: "photo", accessor: "photoUrl" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit" onClick={() => onEdit(row.id)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Staff" child="All Staff" />

        {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
        {successMsg && <div className="alert alert-success">{successMsg}</div>}

        {showModal && (
          <>
            <AddEditBarber
              onCreated={fetchBarbers}
              barber={editbarber}
              onClearbarber={onClearbarber}
              sectionRef={sectionRef}
            />{" "}
          </>
        )}

        <DeleteConfirmationModal
          show={showDeleteModal}
          onClose={() => onCloseDeleteModal()}
          onConfirm={handleConfirmDelete}
          message="Are you sure you want to delete this Barber?"
        />
        <Table
          columns={columns}
          data={barberList}
          onDelete={handleDeleteClick}
          onEdit={onEditClick}
          onAddClick={() => setShowModal(!showModal)}
          title={"All Staff"}
          maxRow={4}
        />
      </div>
    </div>
  );
};

export default Barbers;
